import { render, staticRenderFns } from "./my_message.vue?vue&type=template&id=57586b68&scoped=true"
import script from "./my_message.vue?vue&type=script&lang=js"
export * from "./my_message.vue?vue&type=script&lang=js"
import style0 from "./my_message.vue?vue&type=style&index=0&id=57586b68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57586b68",
  null
  
)

export default component.exports